
import React from 'react';
import { Link } from 'react-router-dom';
import { Music } from 'lucide-react';

const Logo: React.FC = () => {
  return (
    <Link 
      to="/" 
      className="text-xl font-bold flex items-center gap-1.5 group"
    >
      <div className="relative h-8 w-8 rounded-lg flex items-center justify-center bg-gradient-to-br from-neon-purple/80 to-neon-blue/80 p-0.5 overflow-hidden">
        <div className="absolute inset-0 bg-black/80 rounded-[3px] m-[1px]"></div>
        <Music className="h-5 w-5 text-white relative z-10" />
        <div className="absolute inset-0 bg-gradient-to-r from-neon-blue via-neon-purple to-neon-pink opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
      </div>
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple relative">
        Muso360
        <span className="absolute -bottom-0.5 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-neon-blue to-transparent opacity-70"></span>
      </span>
    </Link>
  );
};

export default Logo;
